import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * TRT forms
   */
  {
    // 1
    field: 'trtSymptoms',
    label:
      'Are you currently experiencing any of the following symptoms? Select all that apply',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'lowLibido', value: 'Low libido' },
        { key: 'lowEnergy', value: 'Low energy' },
        { key: 'constantFatigue', value: 'Constant fatigue' },
        { key: 'decreasedConfidence', value: 'Decreased confidence' },
        { key: 'decreasedMuscleMass', value: 'Decreased muscle mass' },
        { key: 'increasedFatMass', value: 'Increased fat mass' },
        { key: 'breastDevelopment', value: 'Breast tissue development' },
        { key: 'lossFacialHair', value: 'Loss of facial and body hair' },
        { key: 'changeTesticleSize', value: 'Change in testicle size' },
        {
          key: 'trtSymptomsNone',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    // 2
    field: 'trtConditions',
    label: 'Do you have any of these conditions? Select all that apply.',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'obstructiveSleep',
          value: 'Symptoms of obstructive sleep apnea or severe snoring'
        },
        {
          key: 'urinarySymptoms',
          value:
            'Urinary symptoms such as frequency, nighttime urination, hesitancy, dribbling, or any known prostate disease'
        },
        {
          key: 'trtConditionsNone',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    // 3
    field: 'trtPhysicalExam',
    label:
      'Have you had a physical exam with a healthcare provider in the past 3 years? If so, did the provider also perform a digital rectal exam? If not, we recommend visiting a healthcare provider before using our Testosterone replacement therapy treatment.',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'trtPhysicalExamYes',
          value: 'Yes, it was normal'
        },
        {
          key: 'trtPhysicalExamYesIssues',
          value: 'Yes, but there were issues',
          answer: {
            label:
              'If there were issues detected in your physical exam, please explain in more detail.',
            type: 'text',
            name: 'trtIssues',
            placeholder: 'Please type here...'
          }
        },
        { key: 'trtPhysicalExamNo', value: 'No' }
      ]
    }
  },
  {
    // 4
    field: 'trtBp',
    label:
      'You need to know your blood pressure (BP) within the last 6 months to receive treatment. It is an important factor deciding whether it is safe for you to receive testosterone replacement therapy.',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Systolic - Top number',
          type: 'number',
          name: 'trtBpSystolic',
          placeholder: 130
        },
        {
          label: 'Diastolic - Bottom number',
          type: 'number',
          name: 'trtBpDiastolic',
          placeholder: 80
        }
      ]
    }
  },
  {
    // 6
    field: 'trtTopBP',
    label:
      'What is the TOP number of your blood pressure reading (i.e. systolic reading) taken in the last 6 months?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'trtTopBP95',
          value: '95 - 119'
        },
        {
          key: 'trtTopBP120',
          value: '120 - 139'
        },
        { key: 'trtTopBP140', value: '140 - 159' },
        { key: 'trtTopBP160', value: '160 or higher' },
        { key: 'trtTopBPLess95', value: 'less than 95' }
      ]
    }
  },
  {
    // 7
    field: 'trtBottomBP',
    label:
      'What is the BOTTOM number of your blood pressure reading (i.e. diastolic reading) taken in the last 6 months?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'trtBottomBP65',
          value: '65 - 80'
        },
        {
          key: 'trtBottomBP81',
          value: '81 - 90'
        },
        { key: 'trtBottomBP91', value: '91 - 100' },
        { key: 'trtBottomBP100', value: 'Over 100' },
        { key: 'trtBottomBPLess65', value: 'less than 65' }
      ]
    }
  },
  {
    // 
    field: 'trtSurgeries',
    label:
      'Do you have any other medical conditions or had surgeries? If yes, please provide furtuer information in detail including current situation, and any prior or ongoing treetment.',
    type: 'info',
    answer: {
      type: 'text',
      name: 'trtSurgeriesDesc',
      placeholder: 'Please type here...'
    }
  },
  {
    // 
    field: 'trtPrescription',
    label:
      'Are you currently taking any prescription or over the counter medications? Specifically mention, if you use any rx/non-rx supplemental hormones, testosterone, steroids at this time or have used in the past. If yes, please list their names and dose.',
    type: 'info',
    answer: {
      type: 'text',
      name: 'trtPrescriptionDesc'
    }
  },
  {
    // 5
    field: 'trtConsume',
    label: 'Do you consume any of the following? Select all that apply.',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'nicotine',
          value: 'Nicotine'
        },
        {
          key: 'marijuana',
          value: 'Marijuana'
        },
        { key: 'alcohol', value: 'Alcohol' },
        { key: 'recreationalDrugs', value: 'Recreational drugs' },
        { key: 'trtConsumeNone', value: 'None Apply', uncheckOthers: true }
      ]
    }
  },
  {
    // 6
    field: 'trtStress',
    label: 'Does any of the following apply to you? Select all that apply.',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'stressfulJob',
          value: 'I am in an overly stressful job'
        },
        {
          key: 'relationshipIssues',
          value: 'I am struggling with relationship issues'
        },
        { key: 'trtConsumeNone', value: 'None Apply', uncheckOthers: true }
      ]
    }
  },
  {
    // 7
    field: 'trtFamilyHistory',
    label: 'Do you have a family history of prostate cancer or strokes?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'trtFamilyHistoryYes',
          value: 'Yes'
        },
        {
          key: 'trtFamilyHistoryNo',
          value: 'No'
        },
        { key: 'trtFamilyHistoryDontKnow', value: "I don't know" }
      ]
    }
  },
  {
    //
    field: 'trtAllergies',
    label:
      'Do you have any allergies to food dyes, medication or anything else? If yes, be sure to include all.',
    type: 'info',
    answer: {
      type: 'text',
      name: 'trtAllergiesDesc',
      placeholder: 'Please type here...'
    }
  },
  {
    // 8
    field: 'trtElse',
    label:
      'Is there anything else we should know? If yes, what else would you like to share about your health or lifestyle?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'trtElseDesc',
      placeholder: 'Please type here...',
      required: false
    }
  },
  {
    // 9
    label: 'BMI',
    field: 'trtBmi',
    type: 'info',
    answer: {
      type: 'bmi',
      showLabel: false,
      bmiLabel: 'BMI',
      heightLabel: 'Height',
      weightLabel: 'Weight'
    }
  },
  {
    //10
    field: 'trtSyringe',
    label:
      'Are you comfortable with withdrawing medication from a vial, into a syringe, and injecting it? (either subcutaneously - under the skin, or intramuscularly- into the muscle)',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'trtSyringeYes',
          value: 'Yes I can do this if I have training'
        },
        {
          key: 'trtSyringeNo',
          value: 'No I have a fear of needles'
        },
        {
          key: 'trtSyringeUnsure',
          value:
            'Unsure, I need more information about the type of injection and frequency. '
        }
      ]
    }
  },
  {
    //11
    field: 'trtWeightIssue',
    label:
      'Do you feel like you have issues with your weight that may or may not be related to low testosterone?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'trWeightYes',
          value: 'Yes, I have weight issues'
        },
        {
          key: 'trtWeightNo',
          value: 'No I do not have any issues with my weight'
        }
      ]
    }
  },
  //12
  {
    field: 'trtHealthBenefits',
    label: 'Do you have health benefits?',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Dietitian benefits?',
          type: 'single_select',
          options: [
            { key: 'dieticianYes', value: 'Yes' },
            { key: 'dieticianNo', value: 'No' },
            { key: 'dieticianDontKnow', value: "I don't know" }
          ]
        },
        {
          label: 'Kinesiologist benefits?',
          type: 'single_select',
          options: [
            { key: 'kinesiologistYes', value: 'Yes' },
            { key: 'kinesiologistNo', value: 'No' },
            { key: 'kinesiologistDontKnow', value: "I don't know" }
          ]
        }
      ]
    }
  },
  {
    // 13
    field: 'trtMoveBody',
    label: 'Body Movement',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'How do you move your body? (multi-select)',
          type: 'multi_select',
          level: 'child',
          options: [
            {
              key: 'walking',
              value: 'Walking'
            },
            {
              key: 'running',
              value: 'Running'
            },
            {
              key: 'weights',
              value: 'Strength Training / Lift Weights'
            },
            {
              key: 'groupClasses',
              value: 'Group Classes (F45, Orange Theory)'
            },
            {
              key: 'Other',
              value: 'Other',
              answer: {
                type: 'text',
                placeholder: 'Please specify',
                name: 'OtherMovement'
              }
            }
          ]
        },
        {
          label:
            'How often to you engage in any of the above physical activities for 30 minutes or more?',
          type: 'single_select',
          level: 'child',
          options: [
            { key: '1-2 times per week', value: '1-2' },
            { key: '3-4 times per week', value: '3-4' },
            { key: '5-6 times per week', value: '5-6' },
            { key: '7+ times per week', value: '7+' }
          ]
        },
        {
          label:
            'Do you feel like your mental health is affected by how you physically feel? ',
          type: 'single_select',
          level: 'child',
          options: [
            { key: 'Yes', value: 'yes' },
            { key: 'No', value: 'no' }
          ]
        }
      ]
    }
  },
  //14
  {
    field: 'trtSleep',
    label: 'Sleep',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'On average, how many hours of sleep do you get per night?',
          type: 'single_select',
          options: [
            { key: 'trtSleep02', value: '0-2 hours' },
            { key: 'trtSleep24', value: '2-4 hours' },
            { key: 'trtSleep56', value: '5-6 hours' },
            { key: 'trtSleep79', value: '7-9 hours' },
            { key: 'trtSleep10', value: '10+ hours' }
          ]
        },
        {
          label: 'How do you usually feel when you wake up in the morning?',
          type: 'single_select',
          options: [
            { key: 'trtSleepExhausted', value: 'Exhausted' },
            { key: 'trtSleepTired', value: 'Tired until I have caffeine' },
            { key: 'trtSleepGroggy', value: 'A bit groggy' },
            { key: 'trtSleepSlow', value: 'Slow to start, but good once I get out of bed' },
            { key: 'trtSleepRested', value: 'Well rested' }
          ]
        },
        {
          label: 'On a scale of 1-5, rate your energy levels during the day. (1 meaning you are exhausted, and 5 meaning you have a lot of energy)',
          type: 'single_select',
          options: [
            { key: 'trtSleep1', value: '1 (I am exhausted)' },
            { key: 'trtSleep2', value: '2' },
            { key: 'trtSleep3', value: '3' },
            { key: 'trtSleep4', value: '4' },
            { key: 'trtSleep5', value: '5 (I have a lot of energy)' }
          ]
        }
      ]
    }
  },
  //15
  {
    field: 'trtDiet',
    label: 'Diet',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'How many times do you eat in a day?',
          type: 'single_select',
          options: [
            { key: 'trtEat1', value: '1' },
            { key: 'trtEat2', value: '2' },
            { key: 'trtEat3', value: '3' },
            { key: 'trtEat4', value: '4' },
            { key: 'trtEat5', value: '5' },
            { key: 'trtEat6', value: '6' },
            { key: 'trtEat7', value: '7+' }
          ]
        },
        {
          label: 'Thinking about your diet in the past few weeks, which of these high protein foods foods do you most commonly eat?',
          subLabel: '(Select at least one, or all that apply.)',
          type: 'multi_select',
          options: [
            {
              key: 'meat',
              value: 'Meat',
              answer: {
                type: 'single_select',
                label: 'Which?',
                level: 'child',
                halfWidth: true,
                options: [
                  { key: 'leanPoultry', value: 'Lean Poultry (e.g. chicken breast/turkey)' },
                  { key: 'nonleanPoultry', value: 'Non-lean Poultry (e.g. chicken drumsticks, wings or thighs/ duck)' },
                  { key: 'beef', value: 'Beef' },
                  { key: 'pork', value: 'Pork' },
                ]
              }
            },
            {
              key: 'fish',
              value: 'Fish/seafood',
              answer: {
                type: 'single_select',
                label: 'which?',
                level: 'child',
                thirdWidth: true,
                options: [
                  { key: 'shrimps', value: 'Shrimp/ pawns' },
                  { key: 'crab', value: 'Crab/ Lobster' },
                  { key: 'clam', value: 'Mollusks (e.g. clam, mussels)' },
                  { key: 'salmon', value: 'Fatty Fish (e.g. salmon, rainbow trout, mackerel, sardines)' },
                  { key: 'whitefish', value: 'White fish (e.g. haddock, cod, tilapia, halibut, snapper, canned tuna)' }
                ]
              }
            },
            {
              key: 'milk',
              value: 'Milk',
              answer: {
                type: 'single_select',
                label: 'which?',
                level: 'child',
                thirdWidth: true,
                options: [
                  { key: 'skim', value: 'Skim milk' },
                  { key: '%1', value: '1% milk' },
                  { key: '%2', value: '2% milk' },
                  { key: '%3.25', value: '3.25% milk' },
                  { key: 'protien', value: 'High protein milk' }
                ]
              }
            },
            {
              key: 'dairy',
              value: 'Dairy Products',
              answer: {
                type: 'single_select',
                label: 'which?',
                level: 'child',
                thirdWidth: true,
                options: [
                  { key: 'yougrt', value: 'Greek/Skyr Yogurt' },
                  { key: 'cheese', value: 'Cheese' }
                ]
              }
            },
            {
              key: 'eggs',
              value: 'Eggs',
              answer: {
                type: 'single_select',
                label: 'which?',
                level: 'child',
                thirdWidth: true,
                options: [
                  { key: 'eggs', value: 'Eggs' },
                  { key: 'eggwhites', value: 'Egg whites' }
                ]
              }
            },
            {
              key: 'vegetarianProducts',
              value: 'Vegetarian Products',
              answer: {
                type: 'single_select',
                label: 'which?',
                level: 'child',
                thirdWidth: true,
                options: [
                  { key: 'extrafirmtofu', value: 'Extra firm tofu' },
                  { key: 'tempeh', value: 'Tempeh' },
                  { key: 'texturedVeg', value: 'Textured Vegetable Protein' },
                  { key: 'edamameorLupini', value: 'Edamame or Lupini' }
                ]
              }
            },
            {
              key: 'highProtien',
              value: 'High Protien',
              answer: {
                type: 'single_select',
                label: 'which?',
                level: 'child',
                thirdWidth: true,
                options: [
                  { key: 'proteinShakes', value: 'Protien shakes' },
                  { key: 'proteinBars', value: 'Protien bars' }
                ]
              }
            },
            { key: 'none', value: 'I eat none of these', uncheckOthers: true },
            {
              value: 'Other',
              type: 'text',
              name: 'trtDietOther',
              placeholder: 'Please specify ...'
            }
          ]
        },
        {
          label: 'On a usual day, how many meals or snacks include protein?',
          type: 'single_select',
          options: [
            { key: 'trtSnack1', value: '1' },
            { key: 'trtSnack2', value: '2' },
            { key: 'trtSnack3', value: '3' },
            { key: 'trtSnack4', value: '4' },
            { key: 'trtSnack5', value: '5' },
            { key: 'trtSnack6', value: '6' },
            { key: 'trtSnack7', value: '7+' }
          ]
        }
      ]
    }
  },
  //13
  {
    field: 'trtStarch',
    label: 'Starch/Grain',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'On a usual day, how many meals or snacks include a starch/grain? (This includes potatoes, rice, bread, pasta, barley etc.)',
          type: 'single_select',
          options: [
            { key: 'trtStarch0', value: '0' },
            { key: 'trtStarch1', value: '1' },
            { key: 'trtStarch2', value: '2' },
            { key: 'trtStarch3', value: '3' },
            { key: 'trtStarch4', value: '4' },
            { key: 'trtStarch5', value: '5' },
            { key: 'trtStarch6', value: '6' },
            { key: 'trtStarch7', value: '7+' }
          ]
        },
        {
          label: 'How many times in a day are consuming high fibre starches or grains (e.g. beans/legumes, quinoa, brown rice, wholegrain bread/wraps/pasta, sweet potatoes, oats)?',
          type: 'single_select',
          options: [
            { key: 'trtStarchHighFibre0', value: '0' },
            { key: 'trtStarchHighFibre1', value: '1' },
            { key: 'trtStarchHighFibre2', value: '2' },
            { key: 'trtStarchHighFibre3', value: '3' },
            { key: 'trtStarchHighFibre4', value: '4' },
            { key: 'trtStarchHighFibre5', value: '5' },
            { key: 'trtStarchHighFibre6', value: '6' },
            { key: 'trtStarchHighFibre7', value: '7+' }
          ]
        },
        {
          label: 'On a usual day, how many meals or snacks include a fruit and/or vegetable?',
          type: 'single_select',
          options: [
            { key: 'trtStarchFruit0', value: '0' },
            { key: 'trtStarchFruit1', value: '1' },
            { key: 'trtStarchFruit2', value: '2' },
            { key: 'trtStarchFruit3', value: '3' },
            { key: 'trtStarchFruit4', value: '4' },
            { key: 'trtStarchFruit5', value: '5' },
            { key: 'trtStarchFruit6', value: '6' },
            { key: 'trtStarchFruit7', value: '7+' }
          ]
        }
      ]
    }
  },
  {
    field: 'trtAcknowledgement',
    label:
      'Some of our prescription options require a medication to be created custom for you. This requires relevant prescription information to be transferred to IHS Compounding Pharmacy. This information will be shared securely and be kept strictly confidential in accordance with the Ontario College of Pharmacy’s regulations.',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [{ key: 'trtAcknowledgement', value: 'I Agree' }]
    }
  }
];

export default questionsModels;
